/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 11L12 14L22 4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.4444 2H11.6C8.23968 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V10.8889"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				fill="currentColor"
			/>
			<path
				d="M16.4444 2H11.6C8.23968 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V10.8889M9 11L12 14L22 4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.98005 2.79497C6.04961 2.25 7.44974 2.25 10.25 2.25H13.75C16.5503 2.25 17.9504 2.25 19.02 2.79497C19.6905 3.13664 20.2717 3.62337 20.7239 4.21547L12 12.9393L9.53033 10.4697C9.23744 10.1768 8.76256 10.1768 8.46967 10.4697C8.17678 10.7626 8.17678 11.2374 8.46967 11.5303L11.4697 14.5303C11.7626 14.8232 12.2374 14.8232 12.5303 14.5303L21.453 5.60766C21.75 6.60953 21.75 7.96269 21.75 10.25V13.75C21.75 16.5503 21.75 17.9504 21.205 19.02C20.7257 19.9608 19.9608 20.7257 19.02 21.205C17.9504 21.75 16.5503 21.75 13.75 21.75H10.25C7.44974 21.75 6.04961 21.75 4.98005 21.205C4.03924 20.7257 3.27433 19.9608 2.79497 19.02C2.25 17.9504 2.25 16.5503 2.25 13.75V10.25C2.25 7.44974 2.25 6.0496 2.79497 4.98005C3.27434 4.03924 4.03924 3.27433 4.98005 2.79497ZM21.453 5.60766L23.5303 3.53033C23.8232 3.23744 23.8232 2.76256 23.5303 2.46967C23.2374 2.17678 22.7626 2.17678 22.4697 2.46967L20.7239 4.21547C20.9061 4.45408 21.0673 4.70981 21.205 4.98005C21.3049 5.17597 21.3864 5.38298 21.453 5.60766Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16.4444 2H9C8.07116 2 7.60674 2 7.21684 2.05133C4.52444 2.40579 2.40579 4.52444 2.05133 7.21684C2 7.60674 2 8.07116 2 9V9V9.5M22 10.8889V12.4C22 15.7603 22 17.4405 21.346 18.7239C20.7708 19.8529 19.8529 20.7708 18.7239 21.346C17.4405 22 15.7603 22 12.4 22H9C8.07116 22 7.60674 22 7.21684 21.9487C4.52444 21.5942 2.40579 19.4756 2.05133 16.7832C2 16.3933 2 15.9288 2 15V15V14.5M9 11L12 14L22 4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16.4444 2H11.6C8.23968 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V10.8889M9 11L12 14L22 4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.25 2.25C7.44974 2.25 6.04961 2.25 4.98005 2.79497C4.03924 3.27433 3.27434 4.03924 2.79497 4.98005C2.25 6.04961 2.25 7.44974 2.25 10.25L2.25 13.75C2.25 16.5503 2.25 17.9504 2.79497 19.02C3.27433 19.9608 4.03924 20.7257 4.98005 21.205C6.04961 21.75 7.44974 21.75 10.25 21.75H13.75C16.5503 21.75 17.9504 21.75 19.02 21.205C19.9608 20.7257 20.7257 19.9608 21.205 19.02C21.75 17.9504 21.75 16.5503 21.75 13.75V10.25C21.75 7.44974 21.75 6.04961 21.205 4.98005C20.7257 4.03924 19.9608 3.27434 19.02 2.79497C17.9504 2.25 16.5503 2.25 13.75 2.25L10.25 2.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.5303 2.46967C23.8232 2.76256 23.8232 3.23744 23.5303 3.53033L12.5303 14.5303C12.2374 14.8232 11.7626 14.8232 11.4697 14.5303L8.46967 11.5303C8.17678 11.2374 8.17678 10.7626 8.46967 10.4697C8.76256 10.1768 9.23744 10.1768 9.53033 10.4697L12 12.9393L22.4697 2.46967C22.7626 2.17678 23.2374 2.17678 23.5303 2.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
